import React from "react";

import { withTimerangeIntelligence } from "../../../shared/containers/containerTimerangeIntelligence";

import IntelligenceDateControl from "./intelligenceDateControl";
import getDates from "./../../../shared/services/date.service";

import { states } from "./../../../reducers/queriesStates";

import styles from "./intelligenceDateTab.module.scss";

const IntelligenceInTimeRangeDateTab = (props) => {
  const { timerangeIntelligenceState, startDate, endDate } = props;

  return (
    <div className={styles.intelligenceDateTab}>
      <div className={styles.control_container}>
        <IntelligenceDateControl isDataReady={true} />
        <span>
          {timerangeIntelligenceState === states.READY
            ? `Сведения за ${getDates.getDateFormat4(startDate)} - ${getDates.getDateFormat4(endDate)}`
            : `Сведения за...`}
        </span>
      </div>
    </div>
  );
};

const areEqual = (prevProps, nextProps) => {
  return prevProps.timerangeIntelligenceState === nextProps.timerangeIntelligenceState;
};

export default withTimerangeIntelligence(React.memo(IntelligenceInTimeRangeDateTab, areEqual));
